import { parseStoryTokenFromPath } from "./storybook/token";

export type SiteRoute =
  | { kind: "home" }
  | { kind: "privacy" }
  | { kind: "terms" }
  | { kind: "contact" }
  | { kind: "story"; token: string | null }
  | { kind: "not_found" };

function normalizePath(pathname: string): string {
  const path = pathname.trim() || "/";
  if (path.length > 1 && path.endsWith("/")) {
    return path.slice(0, -1);
  }
  return path;
}

export function parseRoute(pathname: string): SiteRoute {
  const path = normalizePath(pathname);

  if (path === "/") return { kind: "home" };
  if (path === "/privacy") return { kind: "privacy" };
  if (path === "/terms") return { kind: "terms" };
  if (path === "/contact") return { kind: "contact" };

  if (path === "/story" || path.startsWith("/story/")) {
    return { kind: "story", token: parseStoryTokenFromPath(pathname) };
  }

  return { kind: "not_found" };
}
